var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"el-fade-in"}},[(_vm.trigger)?_c('div',{staticClass:"container"},[_c('img',{staticClass:"loading",attrs:{"src":require("@/assets/images/loading.svg"),"alt":"loading..."}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }